__webpack_require__.p = "/instagram-clone/";